
import MESSAGES from '../../constants/Messages'
import { v4 as uuidv4 } from 'uuid'
import { getBase64Decoded, getFromSessionStorage } from '../../utils/StorageUtils'
import sessionKeys from '../../constants/sessionKeys'
import moment from 'moment'

const REQUIRED_FIELD_ERROR = MESSAGES.FIELD_REQUIRED

export const hasError = (key, error) => {
	if (error !== null && error[key] && error[key] !== '') {
		return true
	} else {
		return false
	}
}

export const removeError = (event, setError) => {
	const id = event.target.id + ''
	setError((prevState) => ({ ...prevState, [id]: '' }))
}

export const validateRequired = (value, setError, key) => {
	if (value &&
		!(typeof value === 'string' || value instanceof String)
	) {
		return true
	} else if (value && value.trim().length) {
		return true
	} else {
		setError((prevState) => ({
			...prevState,
			[key]: REQUIRED_FIELD_ERROR,
		}))
		return false
	}
}


const getFlightDetailsForMutlipleBooking = (flightDetailsData) => {

	if (flightDetailsData && flightDetailsData.length > 0) {
		return flightDetailsData.map((flight) => {
			const flightNum = flight?.flightNumber?.trim();
			return ({
				segmentOrigin: flight?.origin?.code || null,
				segmentDestination: flight?.destination?.code || null,
				flightDate: flight?.flightDate ? moment(flight.flightDate, 'DD-MMM-YYYY').format('DD-MMM-YYYY') : null,
				allotmentId: flight?.allotmentId || null,
				carrierCode: flightNum?.slice(0, 2) || null,
				flightNumber: flightNum?.slice(2) || null,
			})
		})
	} else {
		return [];
	}
}

const parseIfNumber = (str) => {
	if (!str) return null;
	if (str && typeof str !== 'string') return str;
	const num = Number(str);
	return !isNaN(num) && str?.trim() !== '' ? num : null;
};

const getShippingDate = (searchFormData, selectedFlight) => {
	if (!selectedFlight) {
		const shippingDate = searchFormData.shippingDate
			? moment(searchFormData.shippingDate, 'DD-MMM-YYYY').format('DD-MMM-YYYY')
			: null
		return shippingDate
	} else if (selectedFlight) {
		const shippingDate = selectedFlight.departureDateTime
			? moment(selectedFlight.departureDateTime, 'DD-MMM-YYYY').format('DD-MMM-YYYY')
			: null
		return shippingDate
	}
}


const responseRequestBodyMapper = (searchFormData, parsedbookingItem, flightDetailsData, awbNumber) => {
	const { origin, destination, ULDDetails, shippingItemCode, shippingDate, currency, looseDetails, totalWeight, shippingType } = searchFormData || {}
	if (ULDDetails?.length > 0 && shippingType === 'ULD') {
		let totalWeight = 0;
		const updatedULD = ULDDetails?.map((uld) => {
			totalWeight = totalWeight + uld?.pieces * uld?.weight;
			const { pieces, uldVolume, weight, ...rest } = uld || {};
			return { ...rest, numberOfUlds: pieces, uldVolume: parseIfNumber(uldVolume), uldWeight: parseIfNumber(weight) };
		});
		parsedbookingItem.bookingCommodityDetails[0].weight = totalWeight;
		parsedbookingItem.bookingCommodityDetails[0].uldInfoDetaills = updatedULD;
	}
	parsedbookingItem.bookingFlightDetails = getFlightDetailsForMutlipleBooking(flightDetailsData);

	//console.log(bookingItem)
	if (shippingItemCode?.code) {
		let bookingCommodityDetails = parsedbookingItem?.bookingCommodityDetails[0];
		bookingCommodityDetails.commodityCode = shippingItemCode.code;
		bookingCommodityDetails.shipmentDescription = shippingItemCode.description;
		parsedbookingItem?.sccCodes.splice(0, 1, shippingItemCode.scc);

		let shipmentDetails = parsedbookingItem?.shipmentDetails?.productDetails;
		shipmentDetails.productName = shippingItemCode.product;
	}
	// if (shippingDate) {
	// 	let shipmentDetails = parsedbookingItem?.shipmentDetails;
	// 	shipmentDetails.shippingDate = parsedbookingItem?.bookingFlightDetails[0]?.flightDate
	// }
	if (Array.isArray(parsedbookingItem?.bookingFlightDetails) && parsedbookingItem.bookingFlightDetails.length > 0) {
		const firstSegDate = parsedbookingItem.bookingFlightDetails[0]?.flightDate
			? moment(parsedbookingItem.bookingFlightDetails[0].flightDate, ["DD-MMM-YYYY", "YYYY-MM-DD", moment.ISO_8601]).format("DD-MMM-YYYY")
			: null;
		if (firstSegDate) {
			let shipmentDetails = parsedbookingItem?.shipmentDetails;
			shipmentDetails.shippingDate = firstSegDate;
		}
	} else if (shippingDate) {
		// fallback: retain previous logic if no flight segments were mapped
		let shipmentDetails = parsedbookingItem?.shipmentDetails;
		shipmentDetails.shippingDate = parsedbookingItem?.bookingFlightDetails?.[0]?.flightDate;
	}
	if (currency) {
		let shipmentDetails = parsedbookingItem?.shipmentDetails;
		shipmentDetails.currency = currency;
	}
	looseDetails?.map(i => i.tiltable = i.stackable === true ? "Y" : "N");
	looseDetails?.map(i => i.stackable === true ? i.stackable = "Y" : i.stackable = "N");
	looseDetails?.map(i => i.length = parseIfNumber(i.length));
	looseDetails?.map(i => i.height = parseIfNumber(i.height));
	looseDetails?.map(i => i.width = parseIfNumber(i.width));
	looseDetails?.map(i => i.weight = 0);
	looseDetails?.map(i => i.numberOfPieces = parseIfNumber(i.pieces));
	looseDetails?.map(i => i.pieces = parseIfNumber(i.pieces));
	if (looseDetails?.length >= 0 && shippingType === "LOOSE") {
		parsedbookingItem.bookingCommodityDetails[0].dimensionDetaills = looseDetails;
		parsedbookingItem.bookingCommodityDetails[0].weight = parseIfNumber(totalWeight);
	}
	else {
		parsedbookingItem.bookingCommodityDetails[0].dimensionDetaills = null;
	}
	let bookingCommodityDetails = parsedbookingItem?.bookingCommodityDetails[0];
	let uldVolArr = [];
	if (bookingCommodityDetails?.uldInfoDetaills) {
		bookingCommodityDetails?.uldInfoDetaills?.map((uldItem) => {
			uldVolArr.push(uldItem.uldVolume);
		})
		let totalUldVolume = uldVolArr.reduce(function (acc, val) { return acc + val; }, 0)
		bookingCommodityDetails.uldInfoDetaills.volume = totalUldVolume;
	}

	let shipmentIdentifierObj = parsedbookingItem?.shipmentIdentifierDetails;
	if (shipmentIdentifierObj && awbNumber !== null && awbNumber.trim().length !== 0) {
		let shipmentPrefix = awbNumber?.substring(0, 3);
		let masterDocumentNumber = awbNumber?.substring(4, awbNumber.length);
		shipmentIdentifierObj.shipmentPrefix = parseIfNumber(shipmentPrefix);
		shipmentIdentifierObj.masterDocumentNumber = parseIfNumber(masterDocumentNumber);
	}
	else if (!shipmentIdentifierObj && awbNumber !== null) {
		let shipmentPrefix = awbNumber?.substring(0, 3);
		let masterDocumentNumber = awbNumber?.substring(4, awbNumber.length);
		let newShipmentIdentifierObj = {};
		newShipmentIdentifierObj.shipmentPrefix = parseIfNumber(shipmentPrefix);
		newShipmentIdentifierObj.masterDocumentNumber = parseIfNumber(masterDocumentNumber);
		parsedbookingItem.shipmentIdentifierDetails = newShipmentIdentifierObj;
	}
	else {
		parsedbookingItem.shipmentIdentifierDetails = null;
	}
	// parsedbookingItem.shipmentDetails = {
	// 	...parsedbookingItem?.shipmentDetails,
	// 	shipmentOrigin: origin?.code ?? null,
	// 	shipmentDestination: destination?.code ?? null,
	// 	shippingDate: getShippingDate(searchFormData, flightDetailsData),
	// 	productDetails: {
	// 		productName: (flightDetailsData && flightDetailsData.ratingDetails && flightDetailsData.ratingDetails.length) ?
	// 			flightDetailsData.ratingDetails[0].product : searchFormData.shippingItemCode.product,
	// 	},
	// }
}


export const getResumbitRequestBody = (flightDetailsData, userDetails, awbFieldValue) => {
	const encodedSearchObject = getFromSessionStorage("searchObject");
	const searchFormData = getBase64Decoded(encodedSearchObject);
	const dataFromMultipleBooking = getFromSessionStorage(sessionKeys.MULTIPLE_BOOKING_DATA);
	const decodedData = dataFromMultipleBooking ? getBase64Decoded(dataFromMultipleBooking) : null;
	let bookingDeatilsData = decodedData?.fullBookingData?.bookingDetails;
	// if AWB in storage is not equal to AWB in field, take field value.
	const awbNumber = decodedData?.fullBookingData?.awbNumber?.trim().length !== 0 && decodedData?.fullBookingData?.awbNumber !== awbFieldValue ? awbFieldValue : null;
	responseRequestBodyMapper(searchFormData, bookingDeatilsData, flightDetailsData, awbNumber)
	const apiData = {
		requestID: uuidv4(),
		bookingGrpId: decodedData?.fullBookingData?.bookingGroupId,
		id: decodedData?.fullBookingData?.id,
		fileName: decodedData?.fileName,
		userId: userDetails.userId,
		agentCode: userDetails.agentCode,
		bookingDetails: bookingDeatilsData
	}

	return apiData;
}